import * as Cookies from 'js-cookie';


class CookieService {

    get(key:string):string {
        return Cookies.get(key);
    }

    getAll():any {
        return Cookies.get();
    }

    put(key:string, value:string, options?:any):void {
        Cookies.set(key, value, options);
    }

    remove(key:string):void {
        Cookies.remove(key);
    }

    getObject(key:string):any {
        return Cookies.getJSON(key);
    }


    getQueryStringObject(key: string) {
        if (!key) return null;
        let queryString = this.get(key);
        if(!queryString) return null;

        let fields = queryString.split("&");
        let result = {};
        fields.forEach(function (pair) {
            let keyPair = pair.split('=');
            let key = keyPair[0];
            let value = decodeURIComponent(keyPair[1] || '');

            if (result[key]) {
                if (Object.prototype.toString.call(result[key]) === '[object Array]') {
                    result[key].push(value);
                } else {
                    result[key] = [result[key], value];
                }
            } else {
                result[key] = value;
            }
        });
        return JSON.parse(JSON.stringify(result));
    }

    getDomain(): string {
        return document.domain.split(".").slice(-2).join(".");
    }
}

let cookieService = new CookieService();
export {cookieService}



// WEBPACK FOOTER //
// ./resources/modules/services/CookieService.ts